import { render } from "./FeaturedProductGrid.vue?vue&type=template&id=5154cb90&scoped=true"
import script from "./FeaturedProductGrid.vue?vue&type=script&lang=js"
export * from "./FeaturedProductGrid.vue?vue&type=script&lang=js"

import "./FeaturedProductGrid.vue?vue&type=style&index=0&id=5154cb90&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5154cb90"]])

export default __exports__